import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { RecurringWorkPage } from "@/features/recurringwork/RecurringWorkPage";

const search = z.object({
  peek: z.string().optional(),
  filter: z.enum(["all", "week", "overdue", "paused"]).optional().catch(undefined),
});

export const Route = createFileRoute("/_app/subscriptions/recurring")({
  validateSearch: search,
  component: () => <RecurringWorkPage search={Route.useSearch()} />,
});
